import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './fonts/font.css';
import reportWebVitals from './reportWebVitals';
// import "https://code.jquery.com/jquery-3.3.1.min.js"

 
// $(function () {
//   $('[data-toggle="tooltip"]').tooltip()
// })




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <React.StrictMode>
    <App />
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
